import React, { useState, useCallback } from "react";
import { useDropzone } from "react-dropzone";
import { uploadPost } from "../../utilities/apiHelpers";
import { toast } from "react-toastify";

const FileUploadInput = ({ setUploadedFileUrl }) => {
  const [loading, setLoading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);

  const getUploadKeyWithBaseFolderLocation = (filename) => {
    return `uploads/${Date.now()}/${filename}`;
  };

  const uploadToCloud = useCallback(
    async (file) => {
      if (loading) return;

      try {
        setLoading(true);
        setUploadProgress(0);

        const key = getUploadKeyWithBaseFolderLocation(file.name);

        const payload = {
          key,
          content: file.type,
        };

        const url = await uploadPost(payload);
        if (!url) throw new Error("Upload URL not received");

        const xhr = new XMLHttpRequest();
        xhr.open("PUT", url, true);
        xhr.setRequestHeader("Content-Type", file.type);

        xhr.upload.onprogress = (evt) => {
          if (evt.lengthComputable) {
            const progress = Math.ceil((evt.loaded / evt.total) * 100);
            setUploadProgress(progress);
          }
        };

        xhr.onload = () => {
          setLoading(false);
          if (xhr.status === 200) {
            const fileUrl = url.split("?")[0];
            setUploadedFileUrl(fileUrl);
            toast.success("Image uploaded successfully");
          } else {
            toast.error("Upload failed");
          }
        };

        xhr.onerror = () => {
          setLoading(false);
          toast.error("Upload error");
        };

        xhr.send(file);
      } catch (error) {
        setLoading(false);
        setUploadProgress(0);
        toast.error("Something went wrong while uploading");
      }
    },
    [loading, setUploadedFileUrl]
  );

  const onDrop = useCallback(
    (acceptedFiles) => {
      const file = acceptedFiles?.[0];
      if (!file) return;

      if (!file.type.startsWith("image/")) {
        toast.error("Please upload a valid image file");
        return;
      }

      uploadToCloud(file);
    },
    [uploadToCloud]
  );

  const { getRootProps, getInputProps } = useDropzone({
    accept: { "image/*": [] },
    maxFiles: 1,
    onDrop,
  });

  return (
    <div style={{ marginTop: "12px" }}>
      <div
        style={{
          border: "2px dashed #d3d3d3",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "white",
          borderRadius: "5px",
          padding: "30px",
        }}
      >
        <input disabled={loading} {...getInputProps()} />

        <div
          {...getRootProps({ className: "dropzone" })}
          style={{ cursor: "pointer" }}
        >
          {loading ? (
            <div style={{ color: "#9D9D9D" }}>
              Uploading {uploadProgress} %
            </div>
          ) : (
            <h5>Drop image here or click to upload</h5>
          )}
        </div>
      </div>
    </div>
  );
};

export default FileUploadInput;
